// extracted by css-extract-rspack-plugin
export default {"storeHeader":"header-fragment__StoreHeader_storeHeader__a9B5q","header":"header-fragment__StoreHeader_header__6pVb1","aboveNav":"header-fragment__StoreHeader_aboveNav__tYtU1"};